export default __webpack_public_path__ + "static/media/js.3e818d77.webp";